import "./statistics-search.scss";
import CardWrapper from "../../HOC/card/card";
import CustomButton from "../../components/custom-button";
import CustomSelect from "../../components/custom-select";
import { Col, Row } from "antd";
const options = [
  { value: 1, title: "تقارير عامة" },
  { value: 2, title: "تقارير الجهات" },
  { value: 3, title: "تقارير المشاريع" },
];
const StatisticsSearch = () => {
  const handleSubmit = () => {};
  return (
    <CardWrapper>
      <div className="statistics-search-container">
        <Row style={{ width: "100%" }} gutter={16}>
          <Col className="gutter-row" xxl={18} xl={18} lg={18} md={18} sm={24} xs={24}>
          
            <CustomSelect
              styles={{ width: "100%" }}
              options={options}
              placeholder="قم بإختيار التقرير لعرضه"
            />
          </Col>
          <Col className="gutter-row" xxl={6} xl={6} lg={6} md={6} sm={24} xs={24}>
          
            <CustomButton
              handleClick={handleSubmit}
              styles={{ width: "70%", height: "35px", fontSize:"20px", fontWeight:"600" }}
              title="عرض"
            />
          </Col>
        </Row>
      </div>
    </CardWrapper>
  );
};

export default StatisticsSearch;
